import { ReactNode } from "react";
import {
	ChevronDownIcon,
	ArrowDownTrayIcon,
	DocumentIcon,
	DocumentTextIcon,
} from "@heroicons/react/24/outline";
import { Button } from "@headlessui/react";
import { Link, useNavigate } from "react-router";
import { useAppSelector } from "../../app/hooks";
import DropdownMenu from "../../components/Menu";

interface SchoolRosterSectionProps {
	schoolId: number;
	schoolName: string;
	disableRosterImportButton: boolean;
}

export default function SchoolRosterSection({
	schoolId,
	schoolName,
	disableRosterImportButton,
}: SchoolRosterSectionProps) {
	const navigate = useNavigate();

	function onRosterImportClicked() {
		navigate(`/schools/rosterImport?schoolId=${schoolId}&schoolName=${schoolName}`);
	}

	return (
		<section>
			<hr className="my-6" />
			<h2>Roster Import</h2>
			<div className="flex gap-2 mt-2">
				<Button
					type="button"
					className="btn btn-neutral"
					onClick={onRosterImportClicked}
					disabled={disableRosterImportButton}>
					Roster Import
				</Button>
				<DownloadRosterButton />
			</div>
		</section>
	);
}

interface DownloadRosterButtonProps {
	disabled?: boolean;
	className?: string;
}

export function DownloadRosterButton({ disabled, className }: DownloadRosterButtonProps) {
	const { aspUrl } = useAppSelector((state) => state.site);
	return (
		<DropdownMenu
			id="roster-template-download"
			disabled={disabled}
			buttonClassName={className}
			buttonLabel={
				<div className="flex flex-row justify-center items-center">
					<ArrowDownTrayIcon className="size-4 mr-2" aria-hidden="true" />
					Download
					<ChevronDownIcon className="size-4 ml-2" aria-hidden="true" />
				</div>
			}>
			<DownloadRosterLink
				label="Sample Roster"
				url={`${aspUrl}/School/DownloadSampleRoster`}
				icon={<DocumentTextIcon className="size-4" aria-hidden="true" />}
			/>
			<DownloadRosterLink
				label="Blank Roster"
				url={`${aspUrl}/School/DownloadBlankRoster`}
				icon={<DocumentIcon className="size-4" aria-hidden="true" />}
			/>
		</DropdownMenu>
	);
}

interface DownloadRosterLinkProps {
	url: string;
	label: string;
	icon?: ReactNode;
}

function DownloadRosterLink({ url, label, icon }: DownloadRosterLinkProps) {
	return (
		<Link
			className={`block w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100`}
			to={url}
			download={true}>
			<span className="flex items-center">
				{icon && <span className="mr-2 flex items-center">{icon}</span>}
				{label}
			</span>
		</Link>
	);
}
